import { HttpClient } from '@adapters/HttpClient';
import { Manifest, ManifestListResponse, ManifestFilters } from '../models';

export class ManifestListApiAdapter {
  constructor(private httpClient: HttpClient) {}

  async getManifests(filters: ManifestFilters = {}): Promise<ManifestListResponse> {
    const {
      page = 1,
      per_page = 25,
      status,
      courier_integration_id,
      created_from,
      created_to,
      manifest_number,
      sorting,
    } = filters;

    const params: Record<string, any> = {
      page,
      per_page,
    };

    if (status) {
      params['advanced_filters[filters][0][column]'] = 'status';
      params['advanced_filters[filters][0][operator]'] = 'equals';
      params['advanced_filters[filters][0][value]'] = status;
      params['advanced_filters[logic]'] = 'AND';
    }

    if (courier_integration_id) {
      const filterIndex = status ? 1 : 0;
      params[`advanced_filters[filters][${filterIndex}][column]`] = 'courier_integration_id';
      params[`advanced_filters[filters][${filterIndex}][operator]`] = 'equals';
      params[`advanced_filters[filters][${filterIndex}][value]`] = courier_integration_id;
      params['advanced_filters[logic]'] = 'AND';
    }

    if (manifest_number) {
      const filterIndex = (status ? 1 : 0) + (courier_integration_id ? 1 : 0);
      params[`advanced_filters[filters][${filterIndex}][column]`] = 'manifest_number';
      params[`advanced_filters[filters][${filterIndex}][operator]`] = 'contains';
      params[`advanced_filters[filters][${filterIndex}][value]`] = manifest_number;
      params['advanced_filters[logic]'] = 'AND';
    }

    if (sorting?.column && sorting?.direction) {
      params['sorting[column]'] = sorting.column;
      params['sorting[direction]'] = sorting.direction;
    }

    const showGlobalLoading = page === 1;
    const response = await this.httpClient.get<any>(
      '/manifests',
      params,
      {},
      showGlobalLoading
    );

    return {
      data: response.data || [],
      meta: {
        total: response.meta?.total || 0,
        perPage: response.meta?.per_page || per_page,
        currentPage: response.meta?.current_page || page,
        lastPage: response.meta?.last_page || 1,
      },
      links: response.links || {
        first: '',
        prev: null,
        next: null,
        last: '',
      },
    };
  }

  async uploadSignedPdf(manifestId: number, file: File): Promise<Manifest> {
    const formData = new FormData();
    formData.append('file', file, file.name);

    return await this.httpClient.post<Manifest>(
      `/manifests/${manifestId}/signed-pdf`,
      formData,
      true,
      {
        headers: { 'Content-Type': 'multipart/form-data' },
      }
    );
  }

  async complete(manifestId: number): Promise<Manifest> {
    return await this.httpClient.put<Manifest>(
      `/manifests/${manifestId}/complete`,
      {}
    );
  }
}
